import useRoleTagPresenter from "@Totum/Groups/Presentation//hooks/useRoleTagPresenter";
import { ITag } from "@Totum/Main/Components/groups/GroupUtils";
import { CloseOutlined } from "@mui/icons-material";
import { Popconfirm, Tag } from "antd";
import React from "react";

interface IProps {
    tag: ITag;
    color: string;
}

const RoleTag: React.FC<IProps> = ({ tag, color }) => {
    const { handlers, uiModel } = useRoleTagPresenter(tag);

    return (
        <>
            {uiModel.tagVisible ? (
                <Tag
                    key={tag.label}
                    style={{ backgroundColor: color, borderColor: color, display: "flex", width: "fit-content" }}
                    className="role-tag"
                >
                    {tag.label}
                    {uiModel.allowDelete() && "enableDelete" in tag && tag.enableDelete && (
                        <Popconfirm
                            title={uiModel.config?.deleteMessage}
                            visible={uiModel.popupVisible}
                            onVisibleChange={handlers.handleVisibleChange}
                            onConfirm={handlers.confirmDelete}
                            onCancel={handlers.cancelDelete}
                            okText="Yes"
                            cancelText="No"
                            cancelButtonProps={{ className: "secondary" }}
                        >
                            <button className={"no-style"} style={{ paddingLeft: "5px" }}>
                                <CloseOutlined style={{ height: "10px", width: "10px" }} />
                            </button>
                        </Popconfirm>
                    )}
                </Tag>
            ) : null}
        </>
    );
};

export default RoleTag;
